module.exports = __webpack_public_path__ + "static/img/qq_3.06620544.png";